import { render } from "./RegulationRentPage.vue?vue&type=template&id=2fcb1215&scoped=true"
import script from "./RegulationRentPage.vue?vue&type=script&lang=js"
export * from "./RegulationRentPage.vue?vue&type=script&lang=js"

import "./RegulationRentPage.vue?vue&type=style&index=0&id=2fcb1215&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcb1215"]])

export default __exports__